module.exports = __webpack_public_path__ + "static/c2-796f2ce3b3c22ef8165712aea74eb1d2.jpg";